import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Wallet, PlusCircle, Wrench } from "lucide-react";

export default function PettyCash() {
  return (
    <div className="space-y-4" data-testid="petty-cash-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-2xl font-bold text-navy">Petty Cash</h1>
          <p className="text-sm text-muted-foreground">Kas kecil operasional</p>
        </div>
        <Button disabled data-testid="add-petty-cash-btn" className="bg-primary/60 cursor-not-allowed" title="Segera Tersedia">
          <PlusCircle size={16} className="mr-1.5" /> Transaksi Baru
          <span className="ml-2 text-[10px] bg-white/25 rounded px-1.5 py-0.5">Segera Tersedia</span>
        </Button>
      </div>
      <Card className="p-12 flex flex-col items-center justify-center text-center gap-3" data-testid="petty-cash-empty">
        <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center">
          <Wallet size={26} className="text-slate-400" />
        </div>
        <h2 className="font-heading text-base font-semibold text-navy">Belum ada transaksi</h2>
        <p className="text-sm text-muted-foreground max-w-md">
          Modul Petty Cash untuk mencatat kas kecil operasional sedang disiapkan. Belum ada saldo maupun transaksi yang tercatat.
        </p>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-1">
          <Wrench size={13} /> Segera Tersedia
        </div>
      </Card>
    </div>
  );
}
